import { KOBOO_BLUE } from './colors';
import { theme } from '../theme/theme';

export const DEFAULT_MARGIN = '1vh';

const styles = {
  center: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  logo: {
    width: '100%',
    padding: '5% 20%',
  },
  title: {
    color: KOBOO_BLUE,
    fontSize: '3em',
  },
  media: {
    border: '1px dashed black',
    padding: '10px',
    borderRadius: '10px',
  },
  row_container: {
    backgroundColor: theme.palette.primary.dark,
  },
  table: {
    minWidth: 700,
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  fabProgress: {
    color: 'primary',
    position: 'absolute',
    top: -6,
    left: -6,
    zIndex: 1,
  },
  input: {
    marginLeft: 21,
    width: 21,
  }
};

export default styles;



// WEBPACK FOOTER //
// ./src/constants/stylesDefault.js